var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_vm._v("您的系统版本过低,请升级版本")])
}
var staticRenderFns = []

export { render, staticRenderFns }